// 19.1.2.7 Object.getOwnPropertyNames(O)
require(78)('getOwnPropertyNames', function(){
  return require(71).f;
});